<script lang="ts" setup>
import FormsLogin from '@/components/Forms/Login.vue';
import FormsRegister from '@/components/Forms/Register.vue';

const authStore = useAuth();
</script>

<template>
  <div>
    <Tabs
      v-if="!authStore.isAuthenticated"
      :tabs="[
        { label: $t('Login'), handle: 'login' },
        { label: $t('Register'), handle: 'register' },
      ]"
      v-slot="{ activeTab }"
    >
      <div class="pt-4">
        <FormsLogin v-show="activeTab.handle == 'login'"/>
        <FormsRegister @success="activeTab.handle = 'login'" v-show="activeTab.handle == 'register'"/>
      </div>
    </Tabs>
    <div v-else>
      <div class="border rounded-md p-4 shadow-sm bg-white">
        <div class="flex justify-between items-center">
          <div class="flex justify-between flex-col">
            <span class="font-medium text-gray-900">{{ authStore.user?.firstname }} {{ authStore.user?.lastname }}</span>
            <span class="font-medium text-gray-900">{{ authStore.user?.email }}</span>
          </div>
          <span class="text-gray-500">
            <button type="button" @click="authStore.logout()" class="font-medium text-primary-600 hover:text-indigo-500">
              {{ $t('This is not you?') }} {{ $t('Logout') }}
            </button>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
